import React from 'react';
import './Event_about.css';
import creative from '../../img/Event_about/creative.svg'
import creative_mob from '../../img/Event_about/creative_mob.svg'
import list from '../../img/Event_about/list.png'
import img1 from '../../img/Event_about/1.svg'
import img2 from '../../img/Event_about/2.svg'
import img3 from '../../img/Event_about/3.svg'
import img4 from '../../img/Event_about/4.svg'
import img5 from '../../img/Event_about/5.svg'
import img6 from '../../img/Event_about/6.svg'
import img7 from '../../img/Event_about/7.svg'

const Event_about = () => {
    return (
        <div className="about_wrap">
            <div className="about_wrap--header">
                <img className='about_creative about_creative--mob' src={creative_mob} alt="" />
            </div>
            <div className="about container">
                <img className='about_creative about_creative--pc' src={creative} alt="" />
                <div className='about_item'>
                    <img className='about_list' src={img7} alt="" />
                    <p className='about_desc p2'>Web Applications of the Future With TypeScript and GraphQL</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img1} alt="" />
                    <p className='about_desc p2'>Engaging Ecommerce with the Visual Web</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img2} alt="" />
                    <p className='about_desc p2'>How to use React Router V6</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img6} alt="" />
                    <p className='about_desc p2'>Architecture of React applications</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img5} alt="" />
                    <p className='about_desc p2'>Web Performance optimization</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img4} alt="" />
                    <p className='about_desc p2'>React UI Kits for modern web application</p>
                </div>
                <div className='about_item'>
                    <img className='about_list' src={img3} alt="" />
                    <p className='about_desc p2'>Test-Driven Development strategies for React 18</p>
                </div>
            </div>
        </div>
    );
};

export default Event_about;